import { render } from "./VideoTracker.vue?vue&type=template&id=22dd272e&scoped=true"
import script from "./VideoTracker.vue?vue&type=script&lang=js"
export * from "./VideoTracker.vue?vue&type=script&lang=js"

import "./VideoTracker.vue?vue&type=style&index=0&id=22dd272e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22dd272e"]])

export default __exports__